import { render, staticRenderFns } from "./Budjetti.vue?vue&type=template&id=5005cfde&scoped=true"
import script from "./Budjetti.vue?vue&type=script&lang=js"
export * from "./Budjetti.vue?vue&type=script&lang=js"
import style0 from "./Budjetti.vue?vue&type=style&index=0&id=5005cfde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5005cfde",
  null
  
)

export default component.exports